import React from "react";
import { Plus, CheckCircle } from "lucide-react";

const AddTaskModal = ({
  show,
  newTodoText,
  setNewTodoText,
  onSubmit,
  onClose,
  t,
  theme,
  language,
}) => {
  if (!show) return null;

  const handleModalSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (newTodoText.trim()) {
      onSubmit(e);
      onClose();
    }
  };

  return (
    <>
      <div
        onClick={(e) => {
          e.stopPropagation();
          onClose();
          setNewTodoText("");
        }}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0, 0, 0, 0.7)",
          backdropFilter: "blur(8px)",
          zIndex: 999,
          animation: "fadeIn 0.25s ease",
        }}
      />

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          maxWidth: "540px",
          background:
            theme === "dark"
              ? "linear-gradient(145deg, #1e293b 0%, #0f172a 100%)"
              : "linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)",
          borderRadius: "28px",
          padding: "36px",
          zIndex: 1000,
          boxShadow:
            theme === "dark"
              ? "0 24px 80px rgba(0, 0, 0, 0.9), 0 0 0 1px rgba(16, 185, 129, 0.2)"
              : "0 24px 80px rgba(16, 185, 129, 0.15), 0 0 0 1px rgba(16, 185, 129, 0.1)",
          animation: "modalSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "32px",
          }}
        >
          <div
            style={{ display: "flex", alignItems: "center", gap: "14px" }}
          >
            <div
              style={{
                width: "48px",
                height: "48px",
                borderRadius: "14px",
                background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 8px 24px rgba(16, 185, 129, 0.4)",
              }}
            >
              <Plus size={24} color="#fff" strokeWidth={3} />
            </div>
            <h3
              style={{
                fontSize: "24px",
                fontWeight: "900",
                background: "linear-gradient(135deg, #2e7cba, #2e7cba)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                margin: 0,
              }}
            >
              {t.addNewTask || "إضافة مهمة جديدة"}
            </h3>
          </div>

          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClose();
              setNewTodoText("");
            }}
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "12px",
              background:
                theme === "dark"
                  ? "rgba(255,255,255,0.08)"
                  : "rgba(0,0,0,0.05)",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: theme === "dark" ? "#fff" : "#1a1a1a",
              fontSize: "22px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(239, 68, 68, 0.15)";
              e.currentTarget.style.color = "#ef4444";
              e.currentTarget.style.transform = "rotate(90deg) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background =
                theme === "dark"
                  ? "rgba(255,255,255,0.08)"
                  : "rgba(0,0,0,0.05)";
              e.currentTarget.style.color =
                theme === "dark" ? "#fff" : "#1a1a1a";
              e.currentTarget.style.transform = "rotate(0deg) scale(1)";
            }}
          >
            ✕
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleModalSubmit}>
          <div style={{ marginBottom: "24px" }}>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "14px",
                fontWeight: "700",
                color:
                  theme === "dark"
                    ? "rgba(255,255,255,0.9)"
                    : "rgba(0,0,0,0.85)",
                marginBottom: "12px",
              }}
            >
              <span style={{ fontSize: "18px" }}>📝</span>
              {t.taskDescription || "وصف المهمة"}
            </label>
            <textarea
              value={newTodoText}
              onChange={(e) => {
                e.stopPropagation();
                setNewTodoText(e.target.value);
              }}
              onClick={(e) => e.stopPropagation()}
              onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter" && e.ctrlKey) {
                  handleModalSubmit(e);
                }
              }}
              placeholder={t.typeTaskHere}
              autoFocus
              style={{
                width: "100%",
                minHeight: "140px",
                padding: "18px",
                fontSize: "15px",
                fontWeight: "500",
                border:
                  theme === "dark"
                    ? "2px solid rgba(255,255,255,0.08)"
                    : "2px solid rgba(0,0,0,0.08)",
                borderRadius: "16px",
                background:
                  theme === "dark" ? "rgba(255,255,255,0.03)" : "#fff",
                color: theme === "dark" ? "#fff" : "#1a1a1a",
                outline: "none",
                resize: "vertical",
                fontFamily: "inherit",
                transition: "all 0.3s ease",
                boxSizing: "border-box",
                direction: language === "ar" ? "rtl" : "ltr",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#2e7cba";
                e.target.style.boxShadow =
                  "0 0 0 4px rgba(16, 185, 129, 0.1)";
                e.target.style.background =
                  theme === "dark" ? "rgba(255,255,255,0.05)" : "#fff";
              }}
              onBlur={(e) => {
                e.target.style.borderColor =
                  theme === "dark"
                    ? "rgba(255,255,255,0.08)"
                    : "rgba(0,0,0,0.08)";
                e.target.style.boxShadow = "none";
                e.target.style.background =
                  theme === "dark" ? "rgba(255,255,255,0.03)" : "#fff";
              }}
            />
          </div>

          {/* Buttons */}
          <div style={{ display: "flex", gap: "14px" }}>
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onClose();
                setNewTodoText("");
              }}
              style={{
                flex: 1,
                height: "52px",
                fontSize: "15px",
                fontWeight: "700",
                color: theme === "dark" ? "#fff" : "#1a1a1a",
                background:
                  theme === "dark"
                    ? "rgba(255,255,255,0.08)"
                    : "rgba(0,0,0,0.05)",
                border: "2px solid transparent",
                borderRadius: "14px",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  theme === "dark"
                    ? "rgba(255,255,255,0.12)"
                    : "rgba(0,0,0,0.08)";
                e.currentTarget.style.borderColor =
                  theme === "dark"
                    ? "rgba(255,255,255,0.2)"
                    : "rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background =
                  theme === "dark"
                    ? "rgba(255,255,255,0.08)"
                    : "rgba(0,0,0,0.05)";
                e.currentTarget.style.borderColor = "transparent";
              }}
            >
              {t.cancel || "إلغاء"}
            </button>
            <button
              type="submit"
              disabled={!newTodoText.trim()}
              style={{
                flex: 2,
                height: "52px",
                fontSize: "15px",
                fontWeight: "700",
                color: "#fff",
                background: newTodoText.trim()
                  ? "linear-gradient(135deg, #2e7cba, #2e7cba)"
                  : "rgba(128,128,128,0.3)",
                border: "none",
                borderRadius: "14px",
                cursor: newTodoText.trim() ? "pointer" : "not-allowed",
                transition: "all 0.3s ease",
                boxShadow: newTodoText.trim()
                  ? "0 8px 24px rgba(16, 185, 129, 0.3)"
                  : "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
                opacity: newTodoText.trim() ? 1 : 0.5,
              }}
              onMouseEnter={(e) => {
                if (newTodoText.trim()) {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 32px rgba(16, 185, 129, 0.4)";
                }
              }}
              onMouseLeave={(e) => {
                if (newTodoText.trim()) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 24px rgba(16, 185, 129, 0.3)";
                }
              }}
            >
              <CheckCircle size={20} strokeWidth={2.5} /> {t.addTask}
            </button>
          </div>
        </form>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes modalSlideIn {
          from {
            opacity: 0;
            transform: translate(-50%, -45%) scale(0.9);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
          }
        }
      `}</style>
    </>
  );
};

export default AddTaskModal;
